module.exports = " <label class=\"v-form-switch unselectable\" :class=\"{\\'disabled\\': disabled}\"> <input type=checkbox v-model=checked :disabled=disabled> <i class=icon></i> <slot></slot> </label> ";


//////////////////
// WEBPACK FOOTER
// ./~/_vue-html-loader@1.2.4@vue-html-loader!./~/_vue-loader@8.3.1@vue-loader/lib/selector.js?type=template&index=0!./bootsets/components/form/toggle.vue
// module id = 250
// module chunks = 0